import Model from './Model'

export default class TourExponent extends Model {
    resource() {
        return 'tour-exponents'
    }
}
